// Migrated from latam Prismic Global Variables
export const latamGlobalVariables = {
  'site:cocinas-ocultas': {
    region: 'Ciudad',
    regions: [
      {
        label: 'Bogota',
        value: 'Bogota',
      },
      {
        label: 'Lima',
        value: 'Lima',
      },
      {
        label: 'Medellin',
        value: 'Medellin',
      },
    ],
    restaurant: 'Empresa o Restaurante',
    restaurant_number: 'Nú. de restaurantes',
    restaurant_numbers: [
      {
        label: '0 (aun no tengo restaurante)',
        value: '0 (aun no tengo restaurante)',
      },
      {
        label: '1',
        value: '1',
      },
      {
        label: '2-5',
        value: '2-5',
      },
      {
        label: '6-9',
        value: '6-9',
      },
      {
        label: '10-99',
        value: '10-99',
      },
      {
        label: '100+',
        value: '100+',
      },
    ],
    role: 'Rol',
    roles: [
      {
        label: 'Dueño / Socio',
        value: 'Dueño / Socio',
      },
      {
        label: 'Cargo Directivo',
        value: 'Cargo Directivo',
      },
      {
        label: 'Empleado',
        value: 'Empleado',
      },
      {
        label: 'Administrador',
        value: 'Administrador',
      },
      {
        label: 'Emprendedor',
        value: 'Emprendedor',
      },
    ],
    site_name: 'CocinasOcultas',
    site_url: 'https://cocinasocultas.com',
    submit: 'Enviar',
    terms:
      'He leído, entendido y estoy de acuerdo con las<a href="/privacy">Privacy Policy / Terms & Conditions</a>',
    thank_you_content: {
      text: 'Nuestro equipo se comunicará con usted muy pronto para comprender mejor sus necesidades.',
    },
    thank_you_heading: 'Gracias por su contacto.',
    type_of_restaurant: 'Tipo de restaurante',
    types_of_restaurants: [
      {
        label: 'Restaurante tradicional',
        value: 'Restaurante tradicional',
      },
      {
        label: 'Catering / Preparación de Comidas',
        value: 'Catering / Preparación de Comidas',
      },
      {
        label: 'Food truck',
        value: 'Food truck',
      },
      {
        label: 'Otro',
        value: 'Otro',
      },
    ],
    first_name: 'Nombre',
    last_name: 'Apellido',
    email: 'Email',
    country: 'Colombia',
    country_code: 'co',
    phone: 'Teléfono personal',
    contact_and: 'y',
    contact_cookie_policy: 'la Política de Cookies',
    contact_i_have_read_and_understood: 'He leído y acepto',
    contact_privacy_policy: 'la Política de Privacidad de datos personales',
  },
  'site:kitchen-central': {
    region: 'Cidade de Interesse',
    regions: [
      {
        label: 'Sao Paulo',
        value: 'Sao Paulo',
      },
      {
        label: 'Belo Horizonte',
        value: 'Belo Horizonte',
      },
      {
        label: 'Rio de Janeiro',
        value: 'Rio de Janeiro',
      },
      {
        label: 'Brasilia',
        value: 'Brasilia',
      },
    ],
    restaurant: 'Nome do Restaurante',
    restaurant_number: 'Nº de restaurantes',
    restaurant_numbers: [
      {
        label: '0 (ainda não tenho restaurante)',
        value: '0 (ainda não tenho restaurante)',
      },
      {
        label: '1',
        value: '1',
      },
      {
        label: '2-5',
        value: '2-5',
      },
      {
        label: '6-9',
        value: '6-9',
      },
      {
        label: '10-99',
        value: '10-99',
      },
      {
        label: '100+',
        value: '100+',
      },
    ],
    role: 'Função',
    roles: [
      {
        label: 'Possui/opera',
        value: 'Possui/opera',
      },
      {
        label: 'Gerencia',
        value: 'Gerencia',
      },
      {
        label: 'Chef/Cozinheiro',
        value: 'Chef/Cozinheiro',
      },
      {
        label: 'Interessado no mercado',
        value: 'Interessado no mercado',
      },
    ],
    site_name: 'KitchenCentral',
    site_url: 'https://kitchencentral.com.br',
    submit: 'Quero saber mais',
    terms:
      'Declaro que li, entendi e aceito os <a href="/privacy">Privacy Policy / Terms & Conditions</a>',
    thank_you_content: {
      text: 'Muito em breve nosso time entrará em contato para entender melhor suas necessidades.',
    },
    thank_you_heading: 'Obrigado pelo seu contato.',
    type_of_restaurant: 'Tipo de Restaurante',
    types_of_restaurants: [
      {
        label: 'Restaurante tradicional',
        value: 'Restaurante tradicional',
      },
      {
        label: 'Catering/prep de refeições',
        value: 'Catering/prep de refeições',
      },
      {
        label: 'Food truck',
        value: 'Food truck',
      },
      {
        label: 'Outro',
        value: 'Outro',
      },
    ],
    first_name: 'Nome',
    last_name: 'Sobrenome',
    email: 'Email',
    country: 'Brazil',
    country_code: 'br',
    phone: 'Telefone pessoal',
    contact_and: 'e a',
    contact_cookie_policy: 'Política de Cookies',
    contact_i_have_read_and_understood:
      'Declaro que li, entendi e concordo com a',
    contact_privacy_policy: 'Política de Privacidade',
  },
  'site:pop-kitchens': {
    region: 'Ciudad',
    regions: [
      {
        label: 'Santiago de Chile',
        value: 'Santiago de Chile',
      },
    ],
    restaurant: 'Empresa o Restaurante',
    restaurant_number: 'Nú. de restaurantes',
    restaurant_numbers: [
      {
        label: '0 (aun no tengo restaurante)',
        value: '0 (aun no tengo restaurante)',
      },
      {
        label: '1',
        value: '1',
      },
      {
        label: '2-5',
        value: '2-5',
      },
      {
        label: '6-9',
        value: '6-9',
      },
      {
        label: '10-99',
        value: '10-99',
      },
      {
        label: '100+',
        value: '100+',
      },
    ],
    role: 'Role',
    roles: [
      {
        label: 'Dueño / Socio',
        value: 'Dueño / Socio',
      },
      {
        label: 'Cargo Directivo',
        value: 'Cargo Directivo',
      },
      {
        label: 'Empleado',
        value: 'Empleado',
      },
      {
        label: 'Administrador',
        value: 'Administrador',
      },
      {
        label: 'Emprendedor',
        value: 'Emprendedor',
      },
    ],
    site_name: 'PopKitchens',
    site_url: 'https://popkitchens.net',
    submit: 'Enviar',
    terms:
      'He leído, entendido y estoy de acuerdo con <a href="/privacy">Privacy Policy / Terms & Conditions</a>',
    thank_you_content: {
      text: 'Nuestro equipo se comunicará con usted muy pronto para comprender mejor sus necesidades.',
    },
    thank_you_heading: 'Gracias por su contacto.',
    type_of_restaurant: 'Tipo de restaurante',
    types_of_restaurants: [
      {
        label: 'Restaurante tradicional',
        value: 'Restaurante tradicional',
      },
      {
        label: 'Catering / Preparación de Comidas',
        value: 'Catering / Preparación de Comidas',
      },
      {
        label: 'Food truck',
        value: 'Food truck',
      },
      {
        label: 'Otro',
        value: 'Otro',
      },
    ],
    first_name: 'Nombre',
    last_name: 'Apellido',
    email: 'Email',
    country: 'Chile',
    country_code: 'cl',
    phone: 'Teléfono personal',
    contact_and: 'y',
    contact_cookie_policy: 'la Política de Cookies',
    contact_i_have_read_and_understood: 'He leído y acepto',
    contact_privacy_policy: 'la Política de Privacidad de datos personales',
  },
  'site:virtual-kitchens': {
    region: 'Ciudad',
    regions: [
      {
        label: 'Ciudad de México',
        value: 'Mexico City',
      },
      {
        label: 'Guadalajara',
        value: 'Guadalajara',
      },
    ],
    restaurant: 'Empresa o Restaurante',
    restaurant_number: 'Nú. de restaurantes',
    restaurant_numbers: [
      {
        label: '0 (aun no tengo restaurante)',
        value: '0 (aun no tengo restaurante)',
      },
      {
        label: '1',
        value: '1',
      },
      {
        label: '2-5',
        value: '2-5',
      },
      {
        label: '6-9',
        value: '6-9',
      },
      {
        label: '10-99',
        value: '10-99',
      },
      {
        label: '100+',
        value: '100+',
      },
    ],
    role: 'Rol',
    roles: [
      {
        label: 'Dueño / Socio',
        value: 'Dueño / Socio',
      },
      {
        label: 'Cargo Directivo',
        value: 'Cargo Directivo',
      },
      {
        label: 'Empleado',
        value: 'Empleado',
      },
      {
        label: 'Administrador',
        value: 'Administrador',
      },
      {
        label: 'Emprendedor',
        value: 'Emprendedor',
      },
    ],
    site_name: 'VirtualKitchens',
    site_url: 'https://virtualkitchens.mx',
    submit: 'Enviar',
    terms:
      'He leido y entendido los <a href="/privacy">Términos y Condiciones / Política de Privacidad</a>.',
    thank_you_content: {
      text: 'Muy pronto nuestro equipo se pondrá en contacto contigo.',
    },
    thank_you_heading: 'Gracias por su contacto',
    type_of_restaurant: 'Tipo de restaurante',
    types_of_restaurants: [
      {
        label: 'Restaurante tradicional',
        value: 'Restaurante tradicional',
      },
      {
        label: 'Catering / Preparación de Comidas',
        value: 'Catering / Preparación de Comidas',
      },
      {
        label: 'Food truck',
        value: 'Food truck',
      },
      {
        label: 'Otro',
        value: 'Otro',
      },
    ],
    first_name: 'Nombre',
    last_name: 'Apellido',
    email: 'Email',
    country: 'Mexico',
    country_code: 'mx',
    phone: 'Teléfono personal',
    contact_and: 'y',
    contact_cookie_policy: 'la Política de Cookies',
    contact_i_have_read_and_understood: 'He leído y acepto',
    contact_privacy_policy: 'la Política de Privacidad de datos personales',
  },
};
